import MoonLoader from "react-spinners/MoonLoader";

function Loader({ lessonAddStatus, progress }) {
  return (
    <>

      <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: 10050 }}>
        <MoonLoader
          color="#161515"
          loading={true}
          size={40}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>

      {lessonAddStatus ? (
        <>
          <div className=" d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100" style={{ height: '40px', fontSize: "1rem", zIndex: 10050 }} >
            {progress}%
            {/* <div
              className="progress-bar progress-bar-striped"
              role="progressbar"
              style={{ width: `${progress}%` }}
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {progress}%
            </div> */}
          </div>
        </>
      ) : ("")}
    </>
  );
}

export default Loader;
